// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"387":"5a7a8dc2","453":"074206ff","958":"2393f1eb"}[chunkId] + ".chunk.js");